import jQuery from "jquery";
import Vue from "vue";

const re = /(tablet|ipad|playbook|silk)|(android(?!.*mobile))/i;
let $ = jQuery;

export default () => {
  Vue.directive("is-tablet", {
    isEmpty: true,
    bind(el) {
      let isMobile = re.test(navigator.userAgent);
      if (isMobile) {
        $(el).addClass("is-tablet");
      }
    },
    unbind(el) {
      if ($(el).hasClass("is-tablet")) {
        $(el).removeClass("is-tablet");
      }
    }
  });
};
